export const iconFontAwesomeSportsFitnessTableTennisPaddleBall = (
	<i className="fa-solid fa-table-tennis-paddle-ball"></i>
);
